import { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { Login } from './pages/Login';
import { NotFound } from './pages/NotFound';
import { PrivateRoute } from './components/auth/PrivateRoute';
import { Home } from './pages/Home';
import { EventDetail } from './pages/EventDetail';
import EventPhotos from './pages/EventPhotos';

function App() {
  // Extracts pathname property(key) from an object
  const { pathname } = useLocation();

  // Automatically scrolls to top whenever pathname changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/*" element={<NotFound />} />

      <Route element={<PrivateRoute />}>
        <Route index element={<Home />} />
        <Route path="/event/:id" element={<EventDetail />} />
        <Route path="/eventi-foto/:id" element={<EventPhotos />} />
      </Route>
    </Routes>
  );
}

export default App;
